<template>
  <el-select
    :value="value"
    filterable
    clearable
    :loading="loading"
    :placeholder="$t('parkingAreaSelect2.parkingLotPlaceholder')"
    style="width:100%"
    @change="handleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.paId"
      :label="item.num"
      :value="item.paId"
    />
  </el-select>
</template>

<script>
import { listParkingAreas } from '@/api/fee/carCreateFeeApi'

export default {
  name: 'ParkingAreaSelect2',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: [],
      loading: false
    }
  },
  created() {
    this.loadParkingAreas()
  },
  methods: {
    async loadParkingAreas() {
      this.loading = true
      try {
        const res = await listParkingAreas({
          page: 1,
          row: 100
        })
        this.options = res.parkingAreas || []
      } catch (error) {
        console.error('获取停车场失败:', error)
        this.options = []
      } finally {
        this.loading = false
      }
    },
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
